<template>
    <div>
        <van-nav-bar left-text="返回" @click-left="back" title="方案"    left-arrow/>
        <div class="pt46">
            <van-dropdown-menu>
                <van-dropdown-item @change='changeCrop' v-model="cropId" title="作物" :options="cropArr" />
                <van-dropdown-item   title="品种" ref="variety">
                    <van-tree-select  @click-item='changeVariety' :items="varietyList"  :active-id.sync="varietyId"  :main-active-index.sync="activeIndex"/>
                </van-dropdown-item>
                <van-dropdown-item @change='changeTreeAge' v-model="treeAgeId" title="树龄" :options="treeAge" />
                <!-- <van-dropdown-item v-model="value1" :options="cropArr" /> -->
                <!-- <van-dropdown-item v-model="value1" :options="cropArr" /> -->
                <van-dropdown-item @change='changeProgram' v-model="programId" title="方案" :options="programList" />                
            </van-dropdown-menu>
            <div v-show='isHasCharts' style="padding:15px">
                <p>当前方案:{{chartsArr.name}}</p>
                <div class='antV_charts' style="width:100%">
                    <canvas id="charts" style="width:100%;height:300px"></canvas>
                </div>
            </div>
            <div v-show="!isHasCharts" style="padding:15px"> 暂无数据 </div>

        </div>
        <div style="position:absolute;bottom:0;width:100%">
            <!-- <van-button style="width:50%" :loading='saveBtn'  @touchstart='proSave'  color='#ff881b' :icon='saveIcon'  type="primary">收藏方案</van-button> -->
            <van-button style="width:100%" @click='toDetailed'  type="info">查看方案详情</van-button>
        </div>



        <van-popup  v-model="detailedShow"  position="right"  :style="{ height: '100%',width:'100%',background:'#efeff4',color:'#323233' }">
            <van-nav-bar  title="方案详情"/>
            <div class="pt46">
                <van-dropdown-menu>
                    <van-dropdown-item @change='changeGrow' v-model="growId" title="物候期" :options="growList" />
                </van-dropdown-menu>
            </div>
            <div style="padding:15px">
                <p style="text-align:center;margin-bottom:8px;">{{growTitle}}</p>
                <p class="grow-box" v-html='growText'></p>
            </div>
            <div style="position:absolute;bottom:0;width:100%">            
                <van-button block @click='detailedShow = false'  type="info">返回全年方案</van-button>
            </div>
        </van-popup>
    </div>
</template>

<script>
// const F2 = require('@antv/f2/lib/index')
import F2 from "@antv/f2/lib/index-all";
import {getCropList,getSchemeYear,schemeCollect,getSchemeDetailed} from '@/request/data'
export default {
    name:'fertilizerPro',
    data() {
        return {
            cropList:[],
            cropArr:[],
            cropId:1,
            treeAge:[],
            treeAgeId:1,
            varietyId:8,
            activeIndex:0,
            varietyList:[],
            programList:[
                {text:'水肥方案',value:1},
                {text:'植保方案',value:2},
                {text:'园艺方案',value:3}
            ],
            programId:1,
            node_uuid:'',
            chartsArr:{},
            chartsData:[],
            totalNum:0,
            saveBtn:false,
            saveIcon:'star-o',
            detailedShow:false,
            growList:[],
            growId:1,
            isHasCharts:true,
            growTitle:'',
            growText:[],
            lon:'',
            lat:''

        }
    },
    mounted() {
        this.programId = parseInt(this.$route.query.type)
        this.node_uuid = parseInt(this.$route.query.node_uuid)
        this.lon = this.$route.query.lon
        this.lat = this.$route.query.lat
        console.log(this.lon,this.lat)
        this.getCropList()
        this.getSchemeYear()
    },
    methods: {
        getCropList(){
            getCropList().then(res=>{
                if (res.data.code == 0) {
                    this.cropList = res.data.data
                    this.cropArr = []
                    this.varietyList = []
                    for (let i = 0; i < res.data.data.length; i++) {
                        let data = {}
                        data.text =  res.data.data[i].name
                        data.value =  res.data.data[i].id
                        this.cropArr.push(data)                        
                    }
                    //循环品种 (默认)
                    for (let j = 0; j < res.data.data[0].children.length; j++) {
                            let data ={}
                            data.text = res.data.data[0].children[j].name
                            data.children = []
                            for (let y = 0; y < res.data.data[0].children[j].children.length; y++) {
                                let list = {}
                                list.text = res.data.data[0].children[j].children[y].name
                                list.id = res.data.data[0].children[j].children[y].id
                                data.children.push(list)
                            }
                            this.varietyList.push(data)
                    }
                    //循环树龄 (默认)
                    this.treeAge = []
                    for (let i = 0; i < res.data.data[0].param.length; i++) {
                        let treeData = []
                        treeData.text = res.data.data[0].param[i].name
                        treeData.value = res.data.data[0].param[i].id
                        this.treeAge.push(treeData)
                    }

                    //循环物候期(默认)
                    this.growList = []
                    for (let i = 0; i < res.data.data[0].grow.length; i++) {
                        let growData = []
                        growData.text = res.data.data[0].grow[i].name
                        growData.value = res.data.data[0].grow[i].id
                        this.growList.push(growData)
                    }
                }
                
            })
        },
        changeCrop(id){
            let index
            for (let i = 0; i < this.cropList.length; i++) {
                if (id == this.cropList[i].id) {
                    index = i
                }
            }
            console.log(index)
            //循环品种      
                this.varietyList = []
                for (let j = 0; j < this.cropList[index].children.length; j++) {
                    let data ={}
                    data.text = this.cropList[index].children[j].name
                    data.children = []
                    for (let y = 0; y < this.cropList[index].children[j].children.length; y++) {
                        let list = {}
                        list.text = this.cropList[index].children[j].children[y].name
                        list.id = this.cropList[index].children[j].children[y].id
                        data.children.push(list)
                    }
                    this.varietyList.push(data)
                }

                //循环树龄 (默认)
                this.treeAge = []
                for (let i = 0; i < this.cropList[index].param.length; i++) {
                    let treeData = []
                    treeData.text = this.cropList[index].param[i].name
                    treeData.value = this.cropList[index].param[i].id
                    this.treeAge.push(treeData)
                }

                //循环物候期(默认)
                this.growList = []
                for (let i = 0; i < this.cropList[index].grow.length; i++) {
                    let growData = []
                    growData.text = this.cropList[index].grow[i].name
                    growData.value = this.cropList[index].grow[i].id
                    this.growList.push(growData)
                }



        },
        getSchemeYear(){
            let _that = this
            let data = {}
            data.crop_id = this.varietyId
            data.param_id = this.treeAgeId
            data.node_uuid = this.node_uuid
            data.type = this.programId
            $.ajax({
                     url: 'http://api.map.baidu.com/geocoder/v2/?ak=Ya2nSaqjT3vNrIgba1v4nfWzSxGdtgZD&location='+this.lat+','+this.lon+'&output=json',
                     type: 'GET',
                     dataType: "jsonp",
                     success: function (r) {
                        data.area_code = parseInt(r.result.addressComponent.adcode)
                        //  console.log(res.result.addressComponent)
                        getSchemeYear(data).then(res=>{
                            
                            if (res.data.code == 0) {
                                if (res.data.hasOwnProperty('data')) {                                    
                                    _that.isHasCharts = true
                                    _that.chartsArr = res.data.data
                                    _that.totalNum = 0
                                    _that.chartsData = []
                                    for (let i = 0; i < res.data.data.element.length; i++) {
                                        
                                        let data = {}
                                        data.const = 'const'
                                        data.name = res.data.data.element[i].split(':')[0]
                                        data.percent = parseInt(res.data.data.element[i].split(':')[1])
                                        _that.totalNum+= data.percent
                                        _that.chartsData.push(data)                                    
                                    }                                
                                    _that.addCharts()
                                }else{                                   
                                    _that.isHasCharts = false
                                }
                            }
                        })
                         
                     }
                 });                
                // console.log(data)
                       
            
        },         
        addCharts(){
            let _that = this
           let chart = new F2.Chart({
                id: 'charts',
                pixelRatio: window.devicePixelRatio
            });
            chart.source(this.chartsData);
            chart.coord('polar', {
                transposed: true,
                radius: 0.9,
                innerRadius: 0.5
            });
            chart.axis(false);
            chart.legend(false);
            chart.tooltip(false);
            chart.guide().html({
                position: ['50%', '50%'],
                html: '<div style="text-align: center;width:150px;height: 50px;">\n      <p style="font-size: 12px;color: #999;margin: 0" id="title"></p>\n      <p style="font-size: 18px;color: #343434;margin: 0;font-weight: bold;" id="money"></p>\n      </div>'
            });
            chart.interval().position('const*percent').adjust('stack').color('name', ['#1890FF', '#13C2C2', '#2FC25B', '#FACC14']);
            chart.pieLabel({
                sidePadding: 30,
                activeShape: true,
                label1: function label1(data) {                   
                return {
                    text: ((parseFloat(data.percent)/_that.totalNum)*100).toFixed(2) +'%',
                    fill: '#343434',
                    fontWeight: 'bold'
                };
                },
                label2: function label2(data) {
                return {
                    text: data.name,
                    fill: '#999'
                };
                },
                onClick: function onClick(ev) {
                var data = ev.data;
                if (data) {
                    $('#title').text(data.name);
                    $('#money').text(((parseFloat(data.percent)/_that.totalNum)*100).toFixed(2) +'%');
                }
                }
            });
            chart.render();
        },
        proSave(){
            this.saveBtn = true
            schemeCollect(this.chartsArr.id).then(res=>{
                if (res.data.code == 0) {
                    this.$toast.success('收藏成功');
                    this.saveIcon = 'star'
                }else{
                    this.$toast.fail('收藏失败');
                    this.saveIcon = 'star-o'
                }
                this.saveBtn = false
                console.log(res.data)
            })

        },
        toDetailed(){
            this.detailedShow = true
            this.growId = 1
            this.changeGrow()
        },
        changeGrow(){
            let data = {}
            data.scheme_id = this.chartsArr.id
            data.grow_id = this.growId
            console.log(data)
            getSchemeDetailed(data).then(res=>{
                if (res.data.code == 0) {
                    if (res.data.hasOwnProperty('data')) { 
                        this.growTitle = res.data.data.name
                        this.growText = res.data.data.detail
                    }else{
                        this.growText = '暂无数据'
                    }
                }
                console.log(res.data)
            })
        },
        changeTreeAge(){
            console.log(this.treeAgeId)
            this.getSchemeYear()     
        },
        changeProgram(){
            console.log(this.programId)
            this.getSchemeYear() 
        },
        changeVariety(num){
            console.log(num)
            this.varietyId = num.id
            this.$refs.variety.toggle();
            this.getSchemeYear()

        },
        back(){
            this.$router.go(-1)
        }
    },
}
</script>

<style  scoped>
.van-sidebar-item--select{border-color:#0076bf}
.van-tree-select__item--active{color:#0076bf}
</style>